import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Session lives in httpOnly cookies; ask the server who we are (cached per page load).
let _mePromise = null;

export const fetchMe = (force = false) => {
  if (force || !_mePromise) {
    _mePromise = api.get("/auth/admin/me", { _silentAuth: true }).then((r) => r.data).catch(() => false);
  }
  return _mePromise;
};

export const resetMe = () => { _mePromise = null; };

// null = checking, false = signed out, object = admin user
export function useAdmin() {
  const [me, setMe] = useState(null);
  useEffect(() => {
    let live = true;
    fetchMe().then((u) => live && setMe(u));
    return () => { live = false; };
  }, []);
  return me;
}

export async function logout(everywhere = false) {
  try {
    await api.post(everywhere ? "/auth/admin/logout-all" : "/auth/admin/logout", null, { _silentAuth: true });
  } finally {
    resetMe();
  }
}
